import { Box, Divider, Skeleton } from "@mui/material";

const ServiceCardLoader = ({ width = "370px" }: { width?: string }) => {
  return (
    <Box sx={{ ...styles.root, width: { xs: "100%", md: width } }}>
      {/* Header */}
      <Box sx={styles.header}>
        <Skeleton variant="rectangular" sx={styles.coverImage} />
        <Skeleton variant="rectangular" sx={styles.serviceTypeChip} />
        <Skeleton variant="rectangular" sx={styles.menuButton} />
        <Box sx={styles.avatarContainer}>
          <Skeleton variant="circular" sx={styles.avatar} />
        </Box>
      </Box>
      <Box sx={styles.userInfoContainer}>
        <Box sx={styles.userInfo}>
          <Skeleton variant="text" width={120} height={24} />
          <Skeleton variant="text" width={180} height={18} />
        </Box>
        <Skeleton variant="rectangular" width={60} height={24} sx={{ borderRadius: "16px" }} />
      </Box>

      <Divider sx={{ borderColor: "var(--Gray-200, #EAECF0)" }} />

      {/* Body */}
      <Box sx={styles.body}>
        <Box>
          <Skeleton variant="text" width="80%" height={24} />
          <Skeleton variant="text" width="100%" height={18} />
          <Skeleton variant="text" width="90%" height={18} />
          <Skeleton variant="text" width="40%" height={18} />
        </Box>
        <Box sx={styles.chipContainer}>
          <Skeleton variant="rectangular" width={100} height={22} sx={{ borderRadius: "16px" }} />
          <Skeleton variant="rectangular" width={120} height={22} sx={{ borderRadius: "16px" }} />
        </Box>
        <Box sx={styles.statsContainer}>
          <Skeleton variant="text" width={80} height={18} />
          <Skeleton variant="text" width={80} height={18} />
          <Skeleton variant="text" width={80} height={18} />
        </Box>
      </Box>

      <Divider sx={{ borderColor: "var(--Gray-200, #EAECF0)" }} />

      {/* Footer */}
      <Box sx={styles.footer}>
        <Skeleton variant="rectangular" width={100} height={36} sx={{ borderRadius: "16px" }} />
      </Box>
    </Box>
  );
};

export default ServiceCardLoader;

const styles = {
  root: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    borderRadius: "8px",
    border: "1px solid #D2D7DF",
    boxShadow: "0px 12px 20px 0px rgba(0, 0, 0, 0.04), 0px 0px 2px 0px rgba(0, 0, 0, 0.06)",
    overflow: "hidden",
    flexShrink: 0,
  },
  header: {
    position: "relative",
    paddingBottom: "22px",
  },
  coverImage: {
    width: "100%",
    height: "114px",
  },
  serviceTypeChip: {
    position: "absolute",
    top: "16px",
    left: "16px",
    width: "80px",
    height: "24px",
    borderRadius: "16px",
  },
  menuButton: {
    position: "absolute",
    top: "16px",
    right: "16px",
    width: "32px",
    height: "32px",
    borderRadius: "6px",
  },
  avatarContainer: {
    position: "absolute",
    top: "82px",
    left: "16px",
  },
  avatar: {
    width: "56px",
    height: "56px",
    borderRadius: "50%",
  },
  userInfoContainer: {
    display: "flex",
    justifyContent: "space-between",
    padding: "0 16px",
  },
  userInfo: {
    display: "flex",
    flexDirection: "column",
    gap: "4px",
  },
  body: {
    display: "flex",
    flexDirection: "column",
    gap: "16px",
    padding: "0 16px",
  },
  chipContainer: {
    display: "flex",
    gap: "8px",
    flexWrap: "wrap",
  },
  statsContainer: {
    display: "flex",
    gap: "33px",
  },
  footer: {
    display: "flex",
    justifyContent: "flex-end",
    alignItems: "center",
    padding: "0 16px 16px",
  },
};
